import React from 'react';

import { withStyles } from '@material-ui/core/styles/index';

import Typography from '@material-ui/core/Typography';

const styles = () => ({});

function Footer()
{
    return (
        <div className="flex flex-1 items-center px-24" >
            <Typography>Ooopener</Typography>
        </div>
    );
}

export default withStyles(styles, {withTheme: true})(Footer);


// WEBPACK FOOTER //
// ./src/app/display/Footer.js